const heroSwipers = document.querySelectorAll(".hero-swiper");

heroSwipers.forEach(hero => {
  const speed = hero.dataset.speed;
  const setAutoPlay = hero.dataset.autoPlay === "true";

  const swiper = new Swiper(hero, {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: setAutoPlay ? { delay: speed } : false,
    pagination: {
      el: ".hero-swiper-pagination",
      clickable: true,
    },
    on: {
      slideChange: function() {
        const images = swiper.slides[swiper.activeIndex].querySelectorAll('img')
        images.forEach( elem => {
          const duration = Number(elem.dataset.duration);
          const delay = Number(elem.dataset.delay);

          gsap.fromTo(elem, { opacity: 0, y: 25 }, { opacity: 1, y: 0, duration: 1, delay: delay, ease: 'power2', });
        }) 
      }
    }
  });
});